import { useState, useCallback } from "react";

const useForm = <T>(initialState: T) => {
  const [formData, setFormData] = useState<T>(initialState);

  const handleChange = useCallback(
    (field: keyof T) =>
      (
        event: React.ChangeEvent<
          HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
        >,
      ) => {
        setFormData((prevState) => ({
          ...prevState,
          [field]: event.target.value,
        }));
      },
    [setFormData],
  );

  return { formData, handleChange, setFormData };
};

export default useForm;
